import script from "./events.vue?vue&type=script&setup=true&lang=js"
export * from "./events.vue?vue&type=script&setup=true&lang=js"

import "./events.vue?vue&type=style&index=0&id=55cf60c0&lang=less&scoped=true"

import exportComponent from "G:\\workBench\\my_server_project\\eventvue\\myEvents\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55cf60c0"]])

export default __exports__